module.exports = __webpack_public_path__ + "static/img/suikoden_port_lg.70431ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/suikoden-microsite/suikoden_port_lg.jpg
// module id = 277
// module chunks = 2